<template>
  <div class="welcome-screen">
    <div class="logo-container">
      <img src="@/assets/logo.png" alt="Logo HAK Liezen" class="logo">
    </div>
    <h1>Willkommen an der BHAK/BHAS Liezen!</h1>
    <img src="@/assets/banner_welcome.jpg" alt="Schulgemeinschaft BSC Liezen" class="school-image" />

    <div class="text-container">
      <p>In unserer App kannst du deinen Rundgang digital unterstützen lassen und die Schule interaktiv kennenlernen!</p>
    </div>
    
    <button @click="$router.push('/checklist')">Tour starten</button>
    
    <div class="text-container">
      <h2>Entdecke unsere Plakate!</h2>
      <p>In verschiedenen Räumen hängen Plakate mit QR-Codes. Scanne die Codes, um die Station als besucht zu markieren und tolle Goodies zu gewinnen.</p>
      <router-link to="/qr-scanner">
        <img src="@/assets/qrcode.png" alt="QR-Code Scanner" class="qr-code-image" />
      </router-link>
      <p>Klicke auf das Bild, um zum QR-Scanner zu gelangen.</p>
    </div>

    <div class="text-container">
      <h2>Fülle das Formular zu unserem Newsletter aus!</h2>
      <p>Melde dich über den Link an und hole dir ein Goodie für deine Anmeldung oder <b>schließe alle Stationen ab und melde dich direkt beim Goodie Stand zum Newsletter an, 
        um gleichzeitig an der Verlosung teilzunehmen.</b> Wir helfen dir dich anzumelden!</p>
        <button 
    onclick="window.open('https://forms.office.com/e/HGv2mf3wxE', '_blank')" 
    aria-label="Newsletter-Formular" 
    style="padding: 10px 20px; background-color: #ff6600; color: #fff; border: none; border-radius: 5px; cursor: pointer;"> 
    Zum Newsletter-Formular
  </button>
    </div>

    <div class="section-divider">
      <hr>
        <span>Unsere Social Media Accounts</span>
      <hr>
    </div>

    <div class="social-icons">
      <a href="https://www.facebook.com/hakliezen" target="_blank" aria-label="Facebook">
        <img src="@/assets/facebook-icon.png" alt="Facebook" />
      </a>
      <a href="https://www.tiktok.com/@hakliezen" target="_blank" aria-label="TikTok">
        <img src="@/assets/tiktok-icon.png" alt="TikTok" />
      </a>
      <a href="https://www.instagram.com/hakliezen" target="_blank" aria-label="Instagram">
        <img src="@/assets/instagram-icon.png" alt="Instagram" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WelcomeScreen', // Multi-Word-Name zur Behebung des ESLint-Fehlers
};
</script>


<style scoped>
/* Stil für Willkommensbildschirm */
.school-image {
  max-width: 100%;
  height: auto;
  margin: 20px 0;
  border-radius: 8px;
}

.welcome-screen {
  text-align: center;
  padding: 20px;
}

.logo-container {
  display: inline-flex; /* Verwende inline-flex, um den Container nur so groß wie das Logo zu machen */
  justify-content: center; /* Zentriert das Logo horizontal */
  align-items: center; /* Zentriert das Logo vertikal */
  margin: 10px; /* Abstand um den Container herum */
  /*background-color: #98c1d9;  Optional: Hintergrundfarbe */
  border-radius: 10px; /* Abgerundete Ecken, optional */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Optional: Schatten für Tiefe */
}

.logo {
  max-width: 100%; /* Responsives Logo */
  height: auto; /* Höhe proportional zur Breite */
  max-height: 100px; /* Maximale Höhe des Logos (anpassbar) */
}

.logo-container:hover {
  transform: scale(1.05); /* Leichte Vergrößerung beim Hover */
  transition: transform 0.3s; /* Sanfte Übergangsanimation */
}

.text-container {
  background-color: #98c1d9; /* Hintergrundfarbe */
  color: white; /* Textfarbe */
  border-radius: 8px; /* Abgerundete Ecken */
  padding: 20px; /* Innenabstand */
  margin: 20px 0; /* Abstand vor und nach dem Container */
}

.qr-code-image {
  width: 100px; /* Größe des QR-Codes */
  height: 100px;
  margin-top: 10px;
}

</style>